// @flow

import React, { type Node } from 'react';

import astronautSrc from './astronaut.png';
import { componentFactory } from '../component-factory';

export function Astronaut(): Node {
  return (
    <Image src={astronautSrc} />
  );
}

const Image = componentFactory('img', () => ({
  height: '8em',
  animation: '6s lost-in-space-object linear infinite 0s',
}));
